module.exports = __webpack_public_path__ + "img/Umb30_uv_tie_5460.ad97efc4.svg";